import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { QuickStatsComponent } from '../quick-stats/quick-stats.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { UtilityService } from '../../../../core/utility/services/utility.service';

@Component({
	selector: 'app-sem-quick-stats',
	templateUrl: './sem-quick-stats.component.html',
	styleUrls: ['./sem-quick-stats.component.css']
})
export class SemQuickStatsComponent extends QuickStatsComponent implements OnInit, OnDestroy {
	@Input() iscustomendpoint: any;
	range: string;
	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit() {
		super.ngOnInit();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	requestData() {
		// this.range = this.analyticsService.checkDateRange(this.analyticsService.deprecated_date_avg_position);
		super.requestData();
	}

	processResponseData(response: any) {
		const impressions = UtilityService.isUndefinedOrNull(response[0].impressions) ? 0 : response[0].impressions;
		const clicks = UtilityService.isUndefinedOrNull(response[0].clicks) ? 0 : response[0].clicks;
		const calls = UtilityService.isUndefinedOrNull(response[0].calls) ? 0 : response[0].calls;
		const avgPosition = UtilityService.isUndefinedOrNull(response[0].avg_position) ? 0 : response[0].avg_position;
		const clicksPercentage = UtilityService.isUndefinedOrNull(response[0].clicks_percent)
			? '-- '
			: parseFloat(response[0].clicks_percent).toFixed(2);
		const absTopImpression = UtilityService.isUndefinedOrNull(response[0].abs_top_impression_share)
			? 0
			: response[0].abs_top_impression_share;

		this.quickStatsData = {
			impressions: impressions,
			clicks: clicks,
			calls: calls,
			avgPosition: avgPosition,
			clicksPercentage: clicksPercentage,
			absTopImpression: absTopImpression
		};
	}
}
